
import React from "react";
import { useSearchParams } from "@rivtn/noseur";
import { i18nManager } from "../i18n";
import PageHead from "./common/PageHead";
import MemberCard from "./common/MemberCard";
import Pagination from "./common/Pagination";
import MemberModal from "./common/MemberModal";
import FilterChips from "./common/FilterChips";
import { Utils } from "../../../../utils";
import styles from "../assets/style.module.css";
import { ApiResponseData, BaseService, ITeamMember, ITeamWebsite, OmneHostService, SanitizedResponse } from "../../../../services";

export interface MembersProps {
    website: ITeamWebsite;
}

function Members({ website }: MembersProps) {

    const labels = i18nManager.Labels.members;
    const omnehostService = OmneHostService.getInstance();
    const [members, setMembers] = React.useState<ApiResponseData<ITeamMember>>();
    const [selectedMember, setSelectedMember] = React.useState<ITeamMember | null>(null);
    const { page, setPage, status, setStatus } = useSearchParams({ defaultInit: window.location.search, params: { page: "1", status: "ACTIVE" } });
    const options: [string, string][] = website.members_settings?.show_previous_team_members === false
        ? [["ACTIVE", labels.current]]
        : [["ACTIVE", labels.current], ["LEFT", labels.former], ["", labels.all]];

    React.useEffect(fetchInformation, [omnehostService, page, status]);

    return (<>
        <PageHead kicker={labels.kicker} title={labels.title} subtitle={labels.desc} />
        <section className={styles["section-page"]}>
            <div className={styles["container"]}>
                {options.length > 1 && (<FilterChips value={`${status}`} onChange={setStatus} options={options} />)}
                {(!!members?.content)
                    ? (members.content.length > 0
                        ? (<div className={styles["member-grid"]}>
                            {members.content.map((m) => (<MemberCard key={m.external_id} member={m} onSelect={setSelectedMember} />))}
                        </div>)
                        : Utils.emptyState())
                    : Utils.loadingState()}
                <Pagination page={parseInt(`${page}`)} rowsPerPage={members?.size} totalRecords={members?.total_elements} onPageChange={(p) => setPage(`${p}`)} />
            </div>
        </section>
        {selectedMember && (<MemberModal member={selectedMember} onClose={() => setSelectedMember(null)} />)}
    </>);

    function fetchInformation() {
        setMembers({});
        omnehostService.queryTeamMembers(website.team.public_id, {
            page,
            status,
            sort: "role,DESC",
        }).then(({ apiResponse }: SanitizedResponse<ITeamMember>) => {
            setMembers(apiResponse.data!);
        }).catch(BaseService.reportError);
    }
}

export default Members;
